import React, { useState } from "react";
import Rating from "@mui/material/Rating";

interface ChaletRatingComponentProps {
  name: string;
  defaultValue: number;
  onChange: (value: number) => void;
}

const ChaletRatingComponent: React.FC<ChaletRatingComponentProps> = ({
  name,
  defaultValue,
  onChange,
}) => {
  const [value, setValue] = useState<number>(defaultValue);

  const handleChange = (
    _event: React.SyntheticEvent<Element, Event>,
    newValue: number | null
  ) => {
    const safeValue = newValue ?? 0;
    setValue(safeValue);
    onChange(safeValue);
  };

  // useEffect(() => {
  //   setValue(defaultValue);
  // }, [defaultValue]);

  return (
    <div>
      <div className="refiner-heading">{name}</div>
      <Rating value={value} onChange={handleChange} max={10} />
    </div>
  );
};

export default ChaletRatingComponent;
